export default {
  list: [],
  model: null,

  done: false,

  isReloadRequired: true,
  isLoadingRequired: true
}
